declare const htmx: {
  on(event: string, callback: (...args: unknown[]) => void): void;
};

export default (async () => {
  // Preloader
  const preloaderEl = document.querySelector<HTMLElement>('.js-preloader');
  if (preloaderEl) {
    const { default: preloader } = await import('../../templates/_components/preloader/preloader');
    preloader.init(preloaderEl);
  }

  // Gallery
  const imageGalleryEls = document.querySelectorAll<HTMLElement>('.js-imageGallery');
  if (imageGalleryEls.length > 0) {
    const { default: imageGallery } = await import('../../templates/_components/gallery/images');
    imageGallery.init(imageGalleryEls);
  }

  // swiperHolder
  const swiperHolderEls = document.querySelectorAll<HTMLElement>('.js-swiperHolder');
  if (swiperHolderEls.length > 0) {
    const { default: swiperHolder } = await import(
      '../../templates/_components/slider/swiperHolder'
    );
    swiperHolder.init(swiperHolderEls);
  }

  if (typeof htmx !== 'undefined') {
    htmx.on('htmx:afterSwap', async () => {
      console.log('Sprig-Inhalt aktualisiert, Swiper wird initialisiert...');

      const swiperHolderEls = document.querySelectorAll(
        '.js-swiperHolder',
      ) as NodeListOf<HTMLElement>;
      if (swiperHolderEls.length > 0) {
        try {
          const module = await import('../../templates/_components/slider/swiperHolder');
          const swiperHolder = module.default;
          swiperHolder.init(swiperHolderEls);
        } catch (error) {
          console.error('Fehler beim Laden von Swiper:', error);
        }
      }
    });
  } else {
    console.warn('HTMX ist nicht geladen.');
  }

  // sliderContent
  /* const sliderContentEls = document.querySelectorAll<HTMLElement>('.js-sliderContent');
  if (sliderContentEls.length > 0) {
    const { default: sliderContent } = await import(
      '../../templates/_components/slider/sliderContent'
    );
    sliderContent.init(sliderContentEls);
  } */

  // Navigation Main
  const navigationMainEl = document.querySelector<HTMLElement>('.js-navigationMain');
  if (navigationMainEl) {
    const { default: navigationMain } = await import(
      '../../templates/_components/navigation/navigationMain'
    );
    navigationMain.init(navigationMainEl);
  }

  // Code
  const codeBlockEls = document.querySelectorAll<HTMLElement>('.js-code');
  if (codeBlockEls.length > 0) {
    const { default: code } = await import('../../templates/_components/text/code');
    code.init(codeBlockEls);
  }
})();
